import { useNavigate } from "react-router-dom"
import Typography from "../Typography/Typography"
import styles from "./style.module.css"


interface exploreProp {
    item: string
}

export const Explore: React.FC<exploreProp> = ({
    item,
}) => {

    const navigate = useNavigate()

    return (
        <div className={styles.container}>
            <div className={styles.subContainer}>
                <div className={styles.marketPlace}>
                    <div
                        onClick={() => navigate("/marketPlace")}
                        className={styles.market}
                    >
                        <Typography>
                            MarketPlace
                        </Typography>
                    </div>
                    <div
                        onClick={() => navigate("/marketPlace")}
                        className={styles.arrowContainer}
                    >
                        <div className={styles.arrow}></div>
                    </div>
                    <div className={styles.items}>
                        <Typography>
                            {item}
                        </Typography>
                    </div>
                </div>
                <div>
                    <Typography className={styles.exploreText}>
                        Explore All {item}
                    </Typography>
                </div>
            </div>
        </div>
    )
}